const prefix = '@@current-event';

const FETCH_EVENT_SUCCESS = `${prefix}/FETCH_EVENT_SUCCESS`;
const FETCH_EVENT_ERROR = `${prefix}/FETCH_EVENT_ERROR`;

export {
    FETCH_EVENT_SUCCESS,
    FETCH_EVENT_ERROR,
};
